<template>
  <div>
    <div class="time-input-container">
      <div class="time-input-title">
        Время заказа
      </div>
      <input class="basket-group-inner-input time-input-controller"
             :class="{'field-error': isError}"
             @mouseover="deferInputHover = true"
             @mouseleave="deferInputHover = false"
             name="delivery-order-deferred"
             v-model="setTime" v-mask="'##:##'" :placeholder="'00:00'"/>

      <div class="order-deferred-info" data-type="delivery-order-deferred" v-show="deferInputHover">
        {{ phrases.TEXT_CHOOSE_TIME_FROM}}
        <span class="clock" v-html="convertDeferOrderTime(dateStart)"></span>
        {{phrases.TEXT_TO}} <span v-html="convertDeferOrderTime(dateFinish)"></span>
      </div>
      <div class="order-deferred-error" v-show="deferInputError">
        <span class="order-deferred-error-button-close pp-icon pp-icon-close" @click="deferInputError = false"></span>
        <div v-html="phrases.TEXT_ANAVAILABLE_DELIVERY_ORDER_TIME"></div>
        <span class="clock" v-html="convertDeferOrderTime(dateStart)"></span>
        {{phrases.TEXT_TO}} <span v-html="convertDeferOrderTime(dateFinish)"></span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "TimerInput",
    props: {
      selectedTime: {
        type: String,
      },
      selectedDate: {
        type: String,
        required: true
      },
      dateStart: {
        type: String,
        required: true
      },
      dateFinish: {
        type: String,
        required: true
      },
      storedTimeRange: {
        type: String
      },
      phrases: {
        type: Object
      }
    },
    data() {
      return {
        deferInputHover: false,
        deferInputError: false,
        setTime: null,
        isError: false
      };
    },
    methods: {
      convertDeferOrderTime: function (date){
        date = new Date(date);
        return [("0" + date.getHours()).slice(-2), ("0" + date.getMinutes()).slice(-2)].join(":");
      },
      formatTime(date) {
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        return `${hours}:${minutes}`;
      },
      verifyDeferTime(){
        if(this.setTime === null || this.setTime.length < 5){
          return false;
        }
        const deferTimeFormatted = this.selectedDate + " " + ((this.setTime) + ":00").slice(0, 8);
        const deferTime = new Date(deferTimeFormatted).getTime();
        const start_ts = new Date(this.dateStart).getTime();
        const finish_ts = new Date(this.dateFinish).getTime();
        if(deferTime > 0) {
          this.deferInputError = (deferTime < start_ts || deferTime > finish_ts);
        }
        return !this.deferInputError;
      },
    },
    watch: {
      setTime: function (value) {
        this.isError = false;
        if(this.verifyDeferTime()){
          this.$emit('selectTime', value);
        }else{
          this.isError = true;
          this.$emit('selectTime', null);
        }
      }
    },
    mounted() {
      if(this.selectedTime !== null && this.selectedTime !== undefined){
        this.setTime = this.selectedTime;
      }
    }
  };
</script>

<style scoped lang="scss">
  .time-input-container{
    display: flex;
    gap: 8px;
    align-items: center;
    position: relative;
  }

  .time-input-title{
    font-weight: 500;
    line-height: 14px;
    font-size: 14px;
  }

  .time-input-controller{
    background-color: #eaeaea;
    border-radius: 0.25rem;
    margin: 0;
    width: 100%;
  }
</style>